module.exports = __webpack_public_path__ + "img/siyou.12e12840.png";